import React from 'react'
import SbEditable from 'storyblok-react'
import Image from 'gatsby-theme-kn/src/components/atoms/Image'
import Slider from 'react-slick'

const DidYouKnowBlock = ({ block }) => {
  function NextArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-right"></i>
      </span>
    )
  }

  function PrevArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-left"></i>
      </span>
    )
  }

  const settings = {
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: block.autoplay === true ? true : false,
    autoplaySpeed: 5000,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow className="slick-prev" />,
    nextArrow: <NextArrow className="slick-next" />,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  }

  return (
    <SbEditable content={block}>
      <section className="did-you-know-block">
        <div className="did-you-know-block-container">
          <Slider {...settings} className="did-you-know-block-slider">
            {block.fact_items?.length > 0 &&
              block.fact_items.map((item, index) => (
                <div className="did-you-know-block-slider-item" key={index}>
                  <div className="did-you-know-block-slider-item-content">
                    <div className="did-you-know-block-slider-item-icon">
                      {item?.image?.length > 0 ? (
                        <Image
                          image={item.image}
                          imageHeight={100}
                          imageWidth={100}
                        />
                      ) : (
                        <i className="fal fa-lightbulb-on"></i>
                      )}
                    </div>
                    <div className="did-you-know-block-slider-item-text">
                      {item?.intro?.length > 0 && (
                        <div className="did-you-know-block-slider-item-intro">
                          {item.intro}
                        </div>
                      )}
                      {item?.text?.length > 0 && (
                        <div className="did-you-know-block-slider-item-fact">
                          {item.text}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
          </Slider>
        </div>
      </section>
    </SbEditable>
  )
}

export default DidYouKnowBlock
